import script from "./BrandFlipsy.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandFlipsy.vue?vue&type=script&setup=true&lang=js"

import "./BrandFlipsy.vue?vue&type=style&index=0&id=5c2b1de3&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2b1de3"]])

export default __exports__